export default __webpack_public_path__ + "media/0d83f9ab3223b35dd805d4460bfa6a17c61db474e8c478fa7a32d3cdc91e12d2.svg";